export default {
  main: '#571224',
  secondary: '#586844',
  contrastingColor: '#ffffff',
  priceColor: '#586844',
  entryBackground: '#571224',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#ffffff',
};
